import { Injectable } from "@angular/core";
import { CustomerOffer } from "../../../../common/data-access/api-client/src/lib/model/customerOffer";


@Injectable({
    providedIn: 'root'
})
export class CustomerVerificationService {
    constructor() { }

    set(offerId: number, accessCode: string, offer: CustomerOffer) {
        sessionStorage.setItem(this.key(offerId, accessCode), JSON.stringify(offer))
    }

    get(offerId: number, accessCode: string): CustomerOffer | null {
        const offer = sessionStorage.getItem(this.key(offerId, accessCode));
        return offer ? JSON.parse(offer) : null;
    }

    isVerified(offerId: number, accessCode: string): boolean {
        return this.get(offerId, accessCode) != null;
    }

    private key(offerId: number, accessCode: string): string {
        return `${offerId}-${accessCode}`;
    }

}